export const LOCAL_STORAGE_KEYS = {
  time: 'tmm_time_format',
  date: 'tmm_date_format',
}
